import { SelectConfig } from '@qfa/forms';
import { DataSource } from '@kinetic-ui/data-layer';
import { useTranslation } from 'react-i18next';
import { useDataSourceOptions } from 'components/DataSources';

function mapDataSourcesToOptionList(nodes: DataSource[]) {
  return nodes.map(({ value }) => ({
    label: value,
    value: value,
  }));
}

export const useLocationTypeField = () => {
  const { t } = useTranslation(['locations', 'common']);

  const locationTypeOptions = useDataSourceOptions('locationType');
  const dataSourceOptions = mapDataSourcesToOptionList(locationTypeOptions);

  return SelectConfig({
    name: 'locationType',
    id: 'locationType',
    label: t('locations:locationType'),
    required: true,
    sortOrder: 'asc',
    options: dataSourceOptions,
  });
};
